var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 45,
    height: 45,
    rx: 6,
    fill: "url(#29_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.522 27.035V22.77c0-1.21-.647-1.784-1.735-1.784-.904 0-1.686.538-2.028 1.075-.22-.672-.77-1.075-1.637-1.075-.904 0-1.686.562-1.93.916v-.77H8.64v5.902h1.552v-3.971c.232-.33.684-.697 1.222-.697.635 0 .88.391.88.941v3.727h1.563v-3.983c.22-.318.672-.684 1.222-.684.635 0 .88.39.88.94v3.727h1.563Zm4.264.146c-1.943 0-3.116-1.417-3.116-3.103 0-1.674 1.173-3.091 3.116-3.091 1.955 0 3.128 1.417 3.128 3.09 0 1.687-1.173 3.104-3.128 3.104Zm0-1.38c.965 0 1.515-.795 1.515-1.723 0-.916-.55-1.71-1.515-1.71-.965 0-1.503.794-1.503 1.71 0 .928.538 1.723 1.503 1.723Zm9.81 1.234v-4.167c0-1.148-.623-1.881-1.918-1.881-.965 0-1.686.464-2.064.916v-.77h-1.552v5.902h1.552v-3.971a1.68 1.68 0 0 1 1.343-.697c.66 0 1.088.281 1.088 1.1v3.568h1.551Zm4.277.146c-1.943 0-3.116-1.417-3.116-3.103 0-1.674 1.173-3.091 3.116-3.091 1.954 0 3.127 1.417 3.127 3.09 0 1.687-1.173 3.104-3.127 3.104Zm0-1.38c.965 0 1.514-.795 1.514-1.723 0-.916-.55-1.71-1.514-1.71-.966 0-1.503.794-1.503 1.71 0 .928.537 1.723 1.503 1.723Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "29_svg__a",
    x1: 23.5,
    y1: 1,
    x2: 23.5,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F434C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191C21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg29);
export default __webpack_public_path__ + "static/media/29.4c63806cb00ee33c498831b1bce36858.svg";
export { ForwardRef as ReactComponent };